import React from "react"

// Data holders for the "Monthly Margins Per Product Line" tab (V2 only —
// kept in its own file, separate from Class.js, so V1 and the existing
// daily-chart classes stay untouched).

// One bar chart's worth of data for a single Route-ProductLine pair: one
// bar per month in the loaded date range, value = that month's margin %.
export class MonthlyBarData {
    constructor(labels, label, data, color) {
        this.labels = labels
        this.datasets = [
            {
                label: label,
                data: data,
                backgroundColor: color,
                borderColor: color,
                borderWidth: 1,
            },
        ]
    }
}

// A single Route-ProductLine card: the bar chart itself (BarData) plus,
// for each bar/month in the same order as BarData.labels, the raw invoice
// line items that make up that month (MonthlyGroups) — so a bar click can
// hand that month's lines straight to the existing "Margins Per Item" tab
// without re-deriving them from AllData.
export class MonthlyProdLine {
    constructor(Route, ProdLine, Options, BarData, MonthlyGroups) {
        this.Route = Route
        this.ProdLine = ProdLine
        this.Title = Route + '-' + ProdLine
        this.OptionsBarGraph = Options
        this.BarData = BarData
        this.MonthlyGroups = MonthlyGroups // [{ monthKey: "2026-08", monthLabel: "August 2026", lines: [...] }, ...]
        this.Reference = React.createRef()
    }
}
